import React, { useState } from "react";
import axios from "axios";
import Header from "../Header";
import { useAuth0 } from "@auth0/auth0-react";
import BaseContainerDividingLineRHSSidebar from "../BaseContainerDividingLineRHSSidebar";
import RegisteredButton from "../RegisteredButton";
import NonRegisteredButton from "../NonRegisteredButton";
import TFSAAgeDropdown from "../TFSAAgeDropdown";
import BackButton from "../BackButton";
import NextButton from "../NextButton";
import GrowthIndexDropdown from "../GrowthIndexDropdown";
import logo from "../../img/group-6@2x.svg";
import InvestmentImageOne from "../../img/rectangle-6518@2x.svg"
import "./InvestmentsRRIF.css"


const InvestmentsRRIF = () => {
    const [rrif, setRrif] = useState("");
    const [annualContribution, setAnnualContribution] = useState("");
    const [age, setAge] = useState('');
    const [inflation, setInflation] = useState('');

    const { user } = useAuth0();

    function getAge(age){
        setAge(age);
        return age;
    }

    function getGrowthIndex(inflation){
        setInflation(inflation);
        return inflation;
    }

    const onSubmit = (e) => {
        e.preventDefault();
        console.log('RRIF: ', rrif, annualContribution, inflation, age)
        axios.get(`http://localhost:4000/RRIF/add?RRIFID=${user.sub}&totalValue=${rrif}&annualCont=${annualContribution}&inflation=${inflation}&stopAge=${age}`)
        .then(response => {
            console.log(response)
            // setSaving(false);
        })
        .catch(error => {
            console.log(error)
        })
    }

    return (
        <div className="container-center-horizontal">
            <div className="investments-rrif screen">
                <div className="flex-col-31">
                    <Header />
                    <div className="overlap-group6-3">
                        <BaseContainerDividingLineRHSSidebar />
                        <div className="investments-8 nunito-bold-black-30px">Investments</div>
                        <div className="annual-contribution nunito-semi-bold-oxford-blue-11-7px">What is the current total value?</div>
                        <img className="rectangle-7005" src={InvestmentImageOne} />
                        <form onSubmit={onSubmit}>
                            <input 
                                className="rrif-total-value"
                                type="number"
                                placeholder="$"
                                onChange={(e) => {
                                    setRrif(e.target.value);
                                    // console.log(totalRRIF);
                                }}
                            />
                            <div className="average-rrif-deposit nunito-semi-bold-oxford-blue-11-7px">On average how much do you contribute to your RRIF annualy?</div>
                            <input
                                className="average-rrif-value"
                                type='number'
                                placeholder="$"
                                onChange={(e) => {
                                    // const yearlyContribution = e.target.value;
                                    setAnnualContribution(e.target.value);
                                    // console.log(yearlyContribution);
                                }}
                            />
                            <div className="contribution-age-stop nunito-semi-bold-oxford-blue-11-7px">At what age do you plan to stop contributing?</div>
                            <TFSAAgeDropdown getAgeData = {getAge} />
                            <div className="growth-index-rrif">Would you like to set growth indexed to inflation?</div>
                            <GrowthIndexDropdown getIndexData={getGrowthIndex} />
                            <button type="submit" className="save-button-tfsa">Save</button>
                        </form>
                        <div className="rectangle-6457-6 border-1px-athens-gray-2"></div>
                        <div className="rectangle-6458-3 border-1px-athens-gray-2"></div>
                        
                        <div className="change-plan">
                            <div className="change-plan-1 nunito-bold-black-20px">Registered</div>
                        </div>
                        <div className="rrif-title nunito-bold-blue-20px">RRIF</div>
                        <NextButton nextPage="/lif-page" />
                        <BackButton backPage="/lira-page" />
                        <RegisteredButton className="nunito-bold-azure-radiance-14px" handLogo={logo} />
                        <NonRegisteredButton />
                    </div>
                </div>
            </div>
        </div>
    );
};
export default InvestmentsRRIF;